export default function KampaniaProgressBar({ doneCount = 0, placowkaCount = 0, loading = false }) {
	const total = Math.max(placowkaCount, 0)
	const done = Math.min(Math.max(doneCount, 0), total || doneCount)
	const percent = total > 0 ? Math.round((done / total) * 100) : 0

	return (
		<div className="mb-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
			<div className="mb-2 flex items-center justify-between gap-4">
				<span className="text-sm font-medium text-gray-700">Postep kampanii</span>
				<span className="text-sm text-gray-600">
					{loading ? '...' : `${done} / ${total} wykonane (${percent}%)`}
				</span>
			</div>
			<div className="h-3 w-full overflow-hidden rounded-full bg-gray-200">
				<div
					className="h-full rounded-full bg-green-500 transition-all duration-300"
					style={{ width: loading ? '0%' : `${percent}%` }}
					role="progressbar"
					aria-valuenow={percent}
					aria-valuemin={0}
					aria-valuemax={100}
					aria-label="Postep kampanii"
				/>
			</div>
		</div>
	)
}
